export enum MessageAttachmentKind {
  OTHER,
  IMAGE,
  VIDEO,
  AUDIO,
  COMPRESSED,
}
